import React, { Fragment } from "react";

import LayoutWrpper from "./LayoutWrapper";
import PlainHeader from "../Header/PlainHeader";

import Announcement from "../Header/Announcement";
import SpecialAnnouncement from "../Header/Announcement/Special";
//import Footer from "../common/Footer";

const withPlainHeader = (Component) => {
  return ({path,...props}) => (
    <LayoutWrpper path={path}>
      <SpecialAnnouncement/>
    	<Announcement />
      <PlainHeader />
      <Component {...props} />
      {/* <Footer /> */}
    </LayoutWrpper>
  );
};

export default withPlainHeader;
